import actionTypes from "../actionTypes"

const updateOnboardingProcess = data => {
  return {
    type: actionTypes.SET_ONBOARDING_PROCESS,
    payload: data,
  }
}

const updateReloadOnboarding = reload => {
  return {
    type: actionTypes.SET_RELOAD_ONBOARDING,
    payload: reload,
  }
}

const updateWelcomeVisible = visible => {
  return {
    type: actionTypes.SET_WELCOME_VISIBLE,
    payload: visible,
  }
}

const updateWelcomeBusinessVisible = visible => {
  return {
    type: actionTypes.SET_WELCOME_BUSINESS_VISIBLE,
    payload: visible,
  }
}

const updateTutorialProcess = tutorialProcess => {
  return {
    type: actionTypes.SET_TUTORIAL_PROCESS,
    payload: tutorialProcess,
  }
}

const updateShowTutorial = visible => {
  return {
    type: actionTypes.SET_SHOW_TUTORIAL,
    payload: visible,
  }
}

const updateTutorialRunning = running => {
  return {
    type: actionTypes.SET_TUTORIAL_RUNNING,
    payload: running,
  }
}

const updateStepIndex = index => {
  return {
    type: actionTypes.SET_STEP_INDEX,
    payload: index,
  }
}

const updateGetExtensionVisible = visible => {
  return {
    type: actionTypes.SET_GET_EXTENSION_VISIBLE,
    payload: visible,
  }
}

const updateTutorialDetailRunning = running => {
  return {
    type: actionTypes.SET_TUTORIAL_DETAIL_RUNNING,
    payload: running,
  }
}

const updateStepDetailIndex = index => {
  return {
    type: actionTypes.SET_STEP_DETAIL_INDEX,
    payload: index,
  }
}

export default {
  updateOnboardingProcess,
  updateReloadOnboarding,
  updateWelcomeVisible,
  updateWelcomeBusinessVisible,
  updateTutorialProcess,
  updateShowTutorial,
  updateTutorialRunning,
  updateStepIndex,
  updateGetExtensionVisible,
  updateTutorialDetailRunning,
  updateStepDetailIndex
}